import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, PlatformLocation } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionItemComponent } from '../../shared/action-item.component';
import { GroupsService } from '../groups.service';
import { PostDto } from '@oracychampions/api-interfaces';
import { gameInfo } from '../../core/game';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'oc-show-image',
  standalone: true,
  imports: [CommonModule, RouterModule, ActionItemComponent],
  template: `
    <div class="modal-container">
      <div class="modal-body">
        <h1>Show Image</h1>
        <!-- <div *ngIf="!imageUrl" class="loading">Loading...</div> -->
        <img *ngIf="imageUrl" [src]="imageUrl" class="ai-image" />
      </div>
      <div class="modal-spacer">
        <oc-action-item icon="tablerX" size="lg" (click)="activeModal.dismiss('Cross click')"></oc-action-item>
      </div>
    </div>
  `,
  styles: `
    .modal-container {
      display: flex;
      min-height: 100vh;
    }

    .modal-body {
      flex: 1;
      flex-basis: 560px;
      padding: 2.5rem 3.5rem;
    }

    .modal-spacer {
      flex: 0; 
    }

    .modal-spacer:last-child {
      padding: 2rem;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
    }

    h1 {
      margin-bottom: 2rem;
    }

    .ai-image {
      max-height: calc(100vh - 160px);
    }
  `,
})
export class ShowImageComponent implements OnInit {
  private platformLocation = inject(PlatformLocation);
  private modalService = inject(NgbModal);
  private toastr = inject(ToastrService);
  private groupsService = inject(GroupsService);
  public activeModal = inject(NgbActiveModal);
  public http = inject(HttpClient);

  public post: PostDto | null = null;
  public imageUrl: string | null = null;

  private games = gameInfo;

  constructor() {
    this.platformLocation.onPopState(() => this.modalService.dismissAll());
  }

  ngOnInit() {
    console.log(this.post);
    this.http.get<any>(`${environment.API}/posts/${this.post?.id}/image`).subscribe((image) => {
      console.log(image);
      this.imageUrl = image.imageUrl;
    });
  }
}
